import React from 'react';
import { Badge } from '../ui/badge';
import { Check } from 'lucide-react';

interface DisabledLabelViewProps {
  labelColumn: string;
  positiveLabels: string[];
  negativeLabels: string[];
}

export const DisabledLabelView: React.FC<DisabledLabelViewProps> = ({
  labelColumn,
  positiveLabels,
  negativeLabels
}) => {
  return (
    <div className="border border-slate-600 rounded-lg p-4 bg-slate-800">
      <div className="flex items-center justify-between mb-4">
        <span className="font-medium text-white">Labels configured</span>
        <Badge variant="outline" className="text-green-400 border-green-400">
          <Check className="w-3 h-3 mr-1" />
          Complete
        </Badge>
      </div>
      <div className="space-y-2">
        <div>
          <span className="text-sm text-slate-300">Column: {labelColumn}</span>
        </div>
        <div>
          <span className="text-sm text-slate-300">Positive: {positiveLabels.join(', ')}</span>
        </div>
        <div>
          <span className="text-sm text-slate-300">Negative: {negativeLabels.join(', ')}</span>
        </div>
      </div>
    </div>
  );
}; 